import * as React from 'react';

import Flex from './primitives/Flex';
import Text from './primitives/Text';

interface IPageTitleProps {
  title?: string;
  marginBottom?: string;
}

const PageTitle: React.FC<IPageTitleProps> = ({ children, title, marginBottom = 6 }) => (
  <Flex flex='0 0 auto' flexDirection='column' mb={marginBottom} mt={4}>
    <Text fontSize={6} fontWeight='bold' mb={children ? 2 : 0}>{title}</Text>
    {children}
  </Flex>
);

export default PageTitle;
